export default __webpack_public_path__ + "static/media/icon_checkbox_active.7b9d17fc.svg";